import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { FADE_ROUTER } from '../animations/fade-router.animation';
import { Agent, AgentService, AgentType } from '../apis/agent.service';
import { LoginService } from '../apis/login.service';
import { UserProfile, UserRole, UserService } from '../apis/user.service';
import { LocalName, LocalStorageService } from '../services/local-storage.service';
import { AppCore } from '../utils/classes/app-core';
import { AppPath } from '../utils/constants/paths';
import { sidebarMenu, SidebarItem } from './sidebar-menu';
import { SoundSettingService } from '../services/sound-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageItem, LanguageService } from '../services/language.service';
import { UserRolesType } from '../utils/constants/user-roles';
import { CurrencyService } from '../services/currency.service';
import { filter } from 'rxjs/operators';
import { AppService, MemberCreditFormData } from '../app.service';
import { PRELOAD_SYSTEM } from '../utils/constants/preload';

@Component({
  selector: 'app-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.scss'],
  animations: [FADE_ROUTER],
})
export class SecureComponent extends AppCore implements OnInit, OnDestroy, AfterViewInit {
  sidebarMenu: SidebarItem[] = [];
  roleItems: UserRole[] = [];
  agentTypeItems: AgentType[] = PRELOAD_SYSTEM.agent_type;
  sidebarOpen = false;

  minute = 1000 * 60;
  itvAuthen: any;

  showChat = false;
  darkTheme = document.getElementById('host-web').classList.contains('dark');
  Badges = {
    DepositAll: 0,
    DepositAuto: 0,
    DepositRequest: 0,
    WithdrawAll: 0,
    WithdrawRequest: 0,
    WithdrawPending: 0,
    WithdrawFailed: 0,
    WithdrawChecking: 0,
  };
  env = environment;

  agentId: number;

  userProile: UserProfile;

  LogOnline = false;
  TransferOnline = false;

  currentSoundSetting: any = {};
  currentLanguage: LanguageItem;

  spRoles: UserRolesType[] = ['Admin Accounting', 'Admin Support', 'Member Password'];
  newNotiTotal = 0;

  memberCreditFormData: MemberCreditFormData = {
    is_add: false,
    member_id: undefined,
  };
  memberClearTurn = undefined;
  constructor(
    private ngRouter: Router,
    private svLogin: LoginService,
    private svUser: UserService,
    private svAgent: AgentService,
    private svLocalStorage: LocalStorageService,
    private DetectRef: ChangeDetectorRef,
    private svSoundSetting: SoundSettingService,
    private ngxTranslate: TranslateService,
    public svLanguage: LanguageService,
    public svCurrency: CurrencyService,
    public svApp: AppService
  ) {
    super();
    this.sidebarMenu = JSON.parse(JSON.stringify(sidebarMenu));

    this.Subscriptions.add(
      this.svUser.roles.subscribe((roles) => {
        this.roleItems = roles;
        this.updateSidebarMenu('roles update');
      })
    );
    this.Subscriptions.add(
      this.svUser.updateRoles$.subscribe(() => {
        this.getRoles();
      })
    );
    this.Subscriptions.add(
      this.svAgent.updateAgentTypes$.subscribe(() => {
        this.getAgentTypes();
      })
    );
    this.Subscriptions.add(
      this.svUser.updateUserProfile$.subscribe(() => {
        this.getProfile();
      })
    );
    this.Subscriptions.add(
      this.svApp.updateAgentId$.subscribe(() => {
        this.svApp.setAgentId$(this.agentId);
      })
    );
    this.Subscriptions.add(
      this.svSoundSetting.settingUpdated$.subscribe((_) => {
        this.currentSoundSetting = this.svSoundSetting.getCurrentSetting();
      })
    );
    this.currentLanguage = this.svLanguage.getLang();
    this.Subscriptions.add(
      this.ngxTranslate.onLangChange.subscribe(() => {
        this.currentLanguage = this.svLanguage.getLang();
      })
    );
    this.currentSoundSetting = this.svSoundSetting.getCurrentSetting();

    this.getAuthentication();
    this.getProfile();

    this.sidebarOpen = this.svLocalStorage.get(LocalName.Sidebar);

    if (this.isAdmin) {
      this.agentId = this.svLocalStorage.get(LocalName.agentId);
      this.svApp.setAgentId$(this.agentId);
      this.currentAgent = this.svLocalStorage.get(LocalName.currentAgent);
      this.svApp.setCurrentAgent$(this.currentAgent);
    }

    // Connect Signalr
    // this.svSignalR.connectNotify();
    // this.svSignalrBank.init();

    this.ngRouter.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e: any) => {
        if (e.url === '/chat' || e.url === '') {
          this.showChat = false;
        } else {
          this.showChat = true;
        }
      });

    const memberCreditFormOffcanvas$ = this.svApp.memberCreditFormOffcanvas$.subscribe((val) => {
      this.memberCreditFormData = val;

      const btnEl = document.querySelector('#btn-open-member-credit-form') as HTMLButtonElement;
      btnEl?.click();
    });
    this.Subscriptions.add(memberCreditFormOffcanvas$);

    const memberClearTurn$ = this.svApp.memberClearTurn$.subscribe((val) => {
      this.memberClearTurn = val;

      const btnEl = document.querySelector('#btn-open-clear-turnover-member') as HTMLButtonElement;
      btnEl?.click();
    });
    this.Subscriptions.add(memberClearTurn$);
  }

  async ngOnInit() {
    await this.getRoles();
    await this.getAgentTypes();
    setTimeout(() => {
      this.setSidebarCollapseToggle(this.ngRouter.url);
    }, 0);
  }
  // override OnInitSystemAgent(): void {
  //   this.agentTypeItems = this.constDataPreload.agent_type as AgentType[];
  //   this.updateSidebarMenu();
  // }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    clearTimeout(this.itvAuthen);
  }
  ngAfterViewInit(): void {
    // fix router in same chilren event not called
    setTimeout(() => {
      document
        .querySelector('#memberCreditFormOffcanvas')
        ?.addEventListener('hide.bs.offcanvas', () => {
          this.svApp.memberCreditClose$.next();
        });
    }, 0);
  }

  onChangeTheme() {
    const element = document.getElementById('host-web');
    element.classList.toggle('dark');
    this.darkTheme = element.classList.contains('dark');
    if (this.darkTheme) {
      localStorage.setItem('theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light');
    }
  }

  getAuthentication() {
    this.svLogin.authentication().subscribe((res) => {
      this.svAuth.setToken(res.Token);
    });

    if (this.itvAuthen) {
      clearTimeout(this.itvAuthen);
    }
    this.itvAuthen = setTimeout(() => {
      this.getAuthentication();
    }, 5 * this.minute);
  }

  getRoles() {
    return new Promise((resolve) => {
      this.svUser.getRoleSelect().subscribe((res) => {
        this.svUser.setRoles(res);
        resolve(true);
      });
    });
  }

  getAgentTypes() {
    return new Promise((resolve) => {
      this.svAgent.getType().subscribe((res) => {
        this.svAgent.setType(res);
        resolve(true);
      });
    });
  }

  setSidebarCollapseToggle(url: string) {
    this.sidebarMenu.forEach((item, index) => {
      if (item.type !== 'menu') {
        return;
      }
      const currentActive = item.menuList.find((menu) => {
        return url.includes(menu.link.join('/'));
      });
      if (!currentActive) {
        return;
      }
      item.expanded = true;
    });
  }

  onLogout() {
    // this.svSignalR.disconnectNotify();
    this.svAuth.logout();
    this.ngRouter.navigate(['', AppPath.login]);
  }

  updateSidebarMenu(from = '') {
    const _sidebarMenu = JSON.parse(JSON.stringify(sidebarMenu));

    const mappedSidebarMenu = this.svApp.mapSidebarMenu(_sidebarMenu);
    this.svApp.setSidebarMenu$(mappedSidebarMenu);

    this.sidebarMenu = this.svApp.filterSidebarAllowed(
      mappedSidebarMenu,
      this.currentUser.Role,
      this.currentUser.AgentType
    );
  }

  OnToggleSideBar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.svLocalStorage.set(LocalName.Sidebar, this.sidebarOpen);
  }
  getProfile() {
    this.svUser.getProfile().subscribe((res) => {
      this.userProile = res;
      this.svUser.setUserProfile(res);

      if (!this.isAdmin) {
        this.svApp.setAgentId$(res.agent.id);
        this.svApp.setCurrentAgent$(res.agent);
      }
    });
  }

  selectAgentChange(event: Agent) {
    this.agentId = event?.id;
    this.svLocalStorage.set(LocalName.agentId, this.agentId);
    this.svLocalStorage.set(LocalName.currentAgent, event);

    this.svApp.updateAgentId$.next();
    this.svApp.setCurrentAgent$(event);
  }
}
